<template>
<div>
<div class="row no-gutters py-2 mb-3 border-bottom">
    <div class="col-sm-12 px-3 company-form-box-title">Provident Fund Slips</div> 
</div>
<div class="card  mt-3">
   <div class="card-body container-fluid">
        
        <div>
            <b-card no-body >
            <b-tabs pills card vertical content-class="" nav-class="mr-1 pr-10 hide-content">
            <b-tab  active>
                    <template v-slot:title >
                        <b-icon icon="list-check"></b-icon> Provident Fund Slip List
                    </template>
                    <div class="card p-3 m-n2 acc-lists border-0 no-shadow">
                    <div class="row clearfix mt-3 mb-3">
                    <div class="col-md-12 custom-taxcard-select">
                        <span class="custom-select-label mr-3">Select fiscal year: </span>
                      <template v-if="(pf_settings.pf_year_end.opt_value ==12)">
                        <b-form-select v-model="fiscals" class="" v-on:change="filterFiscalYear">
                            <b-form-select-option v-for="(year, n) in $years" :key="n" :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </template>
                    <template v-else>
                      <b-form-select v-model="fiscals" class="" v-on:change="filterFiscalYear">
                      <b-form-select-option v-for="(fiscal_year,index)  in fiscal_years" :key="index"  :value="fiscal_year.fiscal_year">{{fiscal_year.fiscal_year}}</b-form-select-option>
                      </b-form-select>
                    </template>
 

                    </div>
                    </div>
                    <div role="tablist">
                        <b-card no-body class="mb-2 no-shadow" v-for="(payslip,index)  in payslips" :key="payslip.id">
                          <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block v-b-toggle="'accordion-'+(index+1)" variant="primary" @click="paySlipLoad(payslip.id)">Provident Fund Slip | {{empdata.name}} | {{payslip.month}} {{payslip.year}} <span class="when-opened float-right"><i class="fa fa-chevron-up" aria-hidden="true"></i></span><span class="when-closed float-right"><i class="fa fa-chevron-down" aria-hidden="true"></i></span></b-button>
                          </b-card-header>
                          <b-collapse :id="'accordion-'+(index+1)" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                             <template>
                              <Employeepfslipdetails :pageurl="pgurl" :payslip="payslip.id" :company="companies[payslip.company_id]"  :pmonth="payslip.month" :pyear="payslip.year" :dynamic_fields="dynamic_fields" :payslipname="'PF Slip for '+empdata.name+' - '+payslip.month+' '+payslip.year" :emp_etin="empdata.etin" :emp_department="payslip.department" :emp_jobposition="payslip.jobposition" :emp_code="emp_public_info.employee_code" :emp_joining="emp_joinng_date" :emp_branch="payslip.branch_name"></Employeepfslipdetails>
                              </template>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                        <a v-if="payslips != ''" :href="pgurl+'/employee_downloadpfslip_all/'+fiscals" class="btn btn-primary float-right mt-4"><b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon> Download All Provident Fund Slips</a>
                      </div>
                    </div>
             </b-tab>
            </b-tabs>
            </b-card>
        
        </div>
    </b-form>
    </div>
    </div>
   </div>
</template>


<script>
import moment from 'moment';
    export default{
        
        mounted() {
        }, 
        
        computed: {
        },
      
        props: ['pageurl'],
        components: {
           // Employeepayslipdetails
        },
        data(){
            return {  
                
                payslips: [],
                empdata: [],
                emp_public_info: [],
                companies: [],
                accpayslips:[],
                fiscal_years: [],
                fiscals: null,
                curr_fiscal: [],
                pgurl:this.$api_url,
                emp_joinng_date: '',
                dynamic_fields:{},
                pf_settings :{pf_year_end:{ opt_value: 0, status: 0 },},
            }
        },
        methods:{            

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
            getEmployeePublicInfo: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/publicinfo' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.emp_public_info = response.data;
                    this.getPayslipDynamicFieldData(this.emp_public_info.employee_id);
                    this.emp_joinng_date =  moment(String(response.data.date_of_joining)).format('D MMMM YYYY');

                }.bind(this));
            },
            getPFSettings: function()
            { 
                
                let currentObj = this;
                axios.get(this.$api_url+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;
                   
                        
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            },

            
            getPayslipDynamicFieldData:function(emp_id) 
            { 
                let formData = new FormData();
                
                formData.append('employee_id', emp_id);

                //currentObj.showoverlay = true;
                
                axios.post(this.$api_url + '/company/payslip-field-settings/get-employee-dynamic-field-data', formData)
				.then(function (response) 
				{

                        var ltData = response.data;
                        this.dynamic_fields =ltData;

                        console.log(this.dynamic_fields);
                    
                }.bind(this));
            },
            
           getpayslips: function(f_year='')
            {

                   axios.get(this.$api_url+'/employeepaysliplists', {
                            params: {
                                fiscal_year: f_year
                            }
                    }).then(function(response){
                    this.payslips = response.data.data.payslips;
                    this.empdata = response.data.data.employee_info;
                    this.companies = response.data.data.companies;
                    this.fiscal_years = response.data.data.fiscal_years;
                    this.curr_fiscal = response.data.data.fiscal_year;
                    this.fiscals = response.data.data.fiscal_year;
                }.bind(this));
            },
            paySlipLoad(card_id){
                if(parseInt(card_id)){
                this.$set(this.accpayslips,card_id,1);
                }
            },
            filterFiscalYear(f_year){
                this.getpayslips(f_year);
            },
            onSubmit:function(e) 
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                
                e.preventDefault();
                let currentObj = this;
                


                });
            },
            
                      
        },
        created: function(){
            this.getPFSettings();
            this.getEmployeePublicInfo();
            this.getpayslips();
        }
    }
</script> 